import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { reducers } from '../store';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthEffect } from '../store/auth/effects.auth';
import { BaseEffect } from '../store/base/effects.base';
import { loaderInterceptor } from './core/components/loader/loader.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { DatePipe } from '@angular/common';
import {
  MsalService,
  MSAL_INSTANCE,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';
import { apiErrorInterceptor } from './core/auth/guards/toasr.interceptor';
import { jwtInterceptor } from './core/auth/guards/jwt.interceptor';
import {
  GoogleLoginProvider,
  SocialLoginModule,
} from '@abacritt/angularx-social-login';
import { PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { ProviderEnvConfigService } from '@gozetta/dispatch-portal';

export const appConfig: ApplicationConfig = {
  providers: [
    ProviderEnvConfigService({
      env: environment.environmentType,
      apiUrl: environment.dispatchUrl,
      ridesCollection: environment.dispatchRidesCollection,
      emergenciesCollection: '',
      adrAdminUrl: environment.dispatchAdrAdminUrl,
      production: environment.dispatchProduction,
      partnerCollection: environment.dispatchPartnerCollection,
      mapDetailsCollection: environment.dispatchMapDetailsCollection,
      conversationsCollection: environment.dispatchConversationsCollection,
      isRunAsLibrary: true,
      isLocal: environment.isLocal,
      rideMapZoomLevel: environment.rideMapZoomLevel,
      cameraStatusesCollection: environment.cameraStatusesCollection,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(reducers),
    provideEffects(AuthEffect, BaseEffect),
    provideStoreDevtools({
      maxAge: 4, // Retains last 25 states
      logOnly: true, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
    }),
    provideRouterStore(),
    provideHttpClient(
      withInterceptors([
        loaderInterceptor,
        jwtInterceptor,
        apiErrorInterceptor,
      ]),
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order: 'normalize, customprimeflex, primeng, customPrimeng',
          },
        },
      },
    }),
    provideHttpClient(),
    MessageService,
    ConfirmationService,
    DatePipe,
    MsalService,
    MsalBroadcastService,
    MsalGuard,
    SocialLoginModule,
    MessageService,
    {
      provide: MSAL_INSTANCE,
      useFactory: () => {
        const msalConfig = {
          auth: {
            clientId: environment.microsoft_client_id,
            authority: 'https://login.microsoftonline.com/common',
            redirect_uri: environment.redirect_uri,
          },
        };

        // Create and return the PublicClientApplication instance
        return new PublicClientApplication(msalConfig);
      },
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        lang: 'en',
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '783896173032-91afo3riksqg88mm8ffh2cjns3f0rtl6.apps.googleusercontent.com',
            ),
            redirect_uri: environment.redirect_uri,
          },
        ],
      },
    },
  ],
};
